module.exports = __webpack_public_path__ + "img/hoodies.c4388da3.svg";